import { EmptyText } from '@silo/ui';

export const PulsePanel = ({ withCharts = false }: { withCharts?: boolean }) => (
  <div className="space-y-6 animate-pulse">
    <div className="w-full rounded-lg bg-shale-750 h-28 md:h-32" />
    <div className="w-full h-10 rounded-lg bg-shale-750" />
    {withCharts ? <PulseCharts /> : null}
  </div>
);

export const PulseAPYChart = () => {
  return (
    <div className="flex flex-col gap-5 animate-pulse">
      <div className="w-1/4 text-lg rounded-lg bg-shale-700">
        <EmptyText />
      </div>
      <div className="w-1/4 text-sm rounded-lg lg:text-base bg-shale-700">
        <EmptyText />
      </div>
      <div className="bg-shale-700 rounded-lg h-[270px] w-full"></div>
    </div>
  );
};

const PulseCharts = () => {
  return (
    <>
      <PulseAPYChart />
      <PulseUtilizationChart />
    </>
  );
};

export const PulseUtilizationChart = () => {
  return (
    <>
      <div className="flex flex-col gap-5 animate-pulse">
        <div className="w-1/3 text-lg rounded-lg bg-shale-700">
          <EmptyText />
        </div>
        <div className="w-full rounded-lg bg-shale-700 h-36"></div>
      </div>
    </>
  );
};
